export default __webpack_public_path__ + "static/media/product-og.3cd096d5.png";